<div class="row hotels" #hotels>
  <div class="hotel" *ngFor="let item of itemList">
    <div class="inner-card">
      <img src={{item.image}} />
    </div>
    <div class="title-price">
      <p class="title">{{item.title}}</p>
      <p class="price">{{item.currency}}{{item.price}}</p>
    </div>
    <p class="description">{{item.description}}</p>
  </div>
</div>